import { render, staticRenderFns } from "./SalesReportThermal.vue?vue&type=template&id=51629573&"
import script from "./SalesReportThermal.vue?vue&type=script&lang=js&"
export * from "./SalesReportThermal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports